import { computed } from 'vue';
import { useStore } from 'vuex';
import useTranslate from '@/utilities/composables/useTranslate';

export default function usePageWindowMeta() {
  const store = useStore();
  const { translate } = useTranslate();

  const currentPageNotFound = computed(
    (): boolean => store.getters.getCurrentPageMode === 'notfound'
  );
  const page: any = computed((): any => store.getters.getPage || {});

  const windowMeta = computed(() => {
    if (currentPageNotFound.value) {
      return { title: 'Page | 404 Page not found' };
    } else {
      return { title: `Page | ${page?.value?.title || translate('pageTitlePlaceholder')}` };
    }
  });

  return {
    windowMeta,
  };
}
